import { BrowserRouter, Routes, Route } from 'react-router-dom';
import MainLayout from '../app/layouts/MainLayout';
import AuthLayout from '../app/layouts/AuthLayout';
import ProtectedRoute from './ProtectedRoute';
import PermissionRoute from './PermissionRoute';
import PublicRoute from './PublicRoute';
import RedirectToLogin from './RedirectToLogin';
import {
  authRoutes,
  dashboardRoutes,
  pageRoutes,
  productRoutes,
  mediaCentreRoutes,
  mediaRoutes,
  menuRoutes,
  footerRoutes,
  topHeaderRoutes,
  feedbackRoutes,
} from './route-config';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<PublicRoute><AuthLayout /></PublicRoute>}>
          {authRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
        </Route>

        <Route element={<ProtectedRoute><MainLayout /></ProtectedRoute>}>
          {dashboardRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
          {pageRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
          {productRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
          {mediaCentreRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
          {mediaRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
          {menuRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<PermissionRoute requiredPermission={r.permission}><r.component /></PermissionRoute>} />
          ))}
          {footerRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<PermissionRoute requiredPermission={r.permission}><r.component /></PermissionRoute>} />
          ))}
          {topHeaderRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<PermissionRoute requiredPermission={r.permission}><r.component /></PermissionRoute>} />
          ))}
          {feedbackRoutes.map((r) => (
            <Route key={r.path} path={r.path} element={<r.component />} />
          ))}
        </Route>

        <Route path="*" element={<RedirectToLogin />} />
      </Routes>
    </BrowserRouter>
  );
}
